import service from './src/index';

export default {
    install(Vue) {
        Vue.prototype.$downLoad = service;
    },
    service
}